import React from 'react';

const Eyes1 = ({ className, fillEyes, fillEyebrows, scale }) => {
  return (
    <svg viewBox="135.701 53.709 212.104 124.862" width={scale ? (212.104 * scale) : "212.104"} height={scale ? (124.862 * scale) : "124.862"} xmlns="http://www.w3.org/2000/svg">
  <g>
    <ellipse stroke={'rgb(0, 0, 0)'} fill={'rgb(255, 255, 255)'} cx="187.941" cy="126.417" rx="52.154" ry="52.154"/>
    <ellipse stroke={'rgb(0, 0, 0)'} fill={'rgb(255, 255, 255)'} cx="295.651" cy="126.417" rx="52.154" ry="52.154"/>
    <ellipse stroke={'rgb(0, 0, 0)'} fill={fillEyes} cx="187.374" cy="147.958" rx="18.707" ry="18.707"/>
    <ellipse stroke={'rgb(0, 0, 0)'} fill={'rgb(255, 255, 255)'} cx="191.626" cy="137.471" rx="6.519" ry="6.519"/>
    <ellipse stroke={'rgb(0, 0, 0)'} fill={fillEyes} cx="293.95" cy="147.391" rx="18.707" ry="18.707"/>
    <ellipse stroke={'rgb(0, 0, 0)'} fill={'rgb(255, 255, 255)'} cx="297.769" cy="138.172" rx="6.519" ry="6.519"/>
    <path fill={fillEyebrows} stroke={fillEyebrows} d="M 341 89.698 C 336.492 81.467 318.991 48.223 279.527 69.907 C 279.527 69.907 267.232 68.187 272.501 64.342 C 301.05 43.51 337.954 54.512 347.459 86.658"/>
    <path fill={fillEyebrows} stroke={fillEyebrows} d="M 205.513 54.843 C 201.005 63.074 183.504 96.318 144.04 74.634 C 144.04 74.634 131.745 76.354 137.014 80.199 C 165.563 101.031 202.467 90.029 211.972 57.883" transform="matrix(-1, 0, 0, -1, 347.67337, 145.675472)"/>
  </g>
</svg>
  );
};

export default Eyes1;